/* eslint-disable react-refresh/only-export-components */
import { createBrowserRouter } from 'react-router-dom'
import { lazy, Suspense } from 'react'
import { RootLayout } from './layouts/root-layout'

// Eager load critical pages
import { HomePage } from './features/home'

// Lazy load secondary pages
const ServicesPage = lazy(() => import('./features/services/services-page'))
const ServiceDetailPage = lazy(() => import('./features/services/service-detail-page'))
const AboutPage = lazy(() => import('./features/about/about-page'))
const ContactPage = lazy(() => import('./features/contact/contact-page'))
const CaseStudiesPage = lazy(() => import('./features/case-studies/case-studies-page'))
const CaseStudyDetailPage = lazy(() => import('./features/case-studies/case-study-detail-page'))
const BlogPage = lazy(() => import('./features/blog/blog-page'))
const BlogArticlePage = lazy(() => import('./features/blog/blog-article-page'))
const CareersPage = lazy(() => import('./features/careers/careers-page'))
const NotFoundPage = lazy(() => import('./features/not-found/not-found-page'))
const PrivacyPolicyPage = lazy(() => import('./features/legal/privacy-policy-page'))
const RoiCalculatorPage = lazy(() => import('./features/tools/roi-calculator-page'))
const AssessmentPage = lazy(() => import('./features/tools/assessment-page'))

// Loading fallback
function PageLoader() {
  return (
    <div className="flex items-center justify-center min-h-[50vh]">
      <div className="animate-pulse text-neutral-500">Loading...</div>
    </div>
  )
}

// Wrap lazy components with Suspense
function withSuspense(Component: React.LazyExoticComponent<() => JSX.Element>) {
  return (
    <Suspense fallback={<PageLoader />}>
      <Component />
    </Suspense>
  )
}

export const router = createBrowserRouter([
  {
    path: '/',
    element: <RootLayout />,
    children: [
      { index: true, element: <HomePage /> },
      { path: 'services', element: withSuspense(ServicesPage) },
      { path: 'services/:slug', element: withSuspense(ServiceDetailPage) },
      { path: 'about', element: withSuspense(AboutPage) },
      { path: 'contact', element: withSuspense(ContactPage) },
      { path: 'case-studies', element: withSuspense(CaseStudiesPage) },
      { path: 'case-studies/:slug', element: withSuspense(CaseStudyDetailPage) },
      { path: 'insights', element: withSuspense(BlogPage) },
      { path: 'insights/:slug', element: withSuspense(BlogArticlePage) },
      { path: 'careers', element: withSuspense(CareersPage) },
      { path: 'privacy', element: withSuspense(PrivacyPolicyPage) },
      { path: 'tools/roi-calculator', element: withSuspense(RoiCalculatorPage) },
      { path: 'tools/assessment', element: withSuspense(AssessmentPage) },
      { path: '*', element: withSuspense(NotFoundPage) },
    ],
  },
])
